import { ColumnProps } from 'antd/lib/table';
import i18n from 'i18n';

export const getColumnsTablePlot = (): Array<ColumnProps<any>> => [
    {
        title: i18n.t('plotagens:resend.columns.request'),
        dataIndex: 'Description',
    },
    {
        title: i18n.t('plotagens:resend.columns.deliverTo'),
        dataIndex: 'PlotterResponsibleName',
    },
];
